// Port of api/fuel/app/classes/controller/api/monty/accounts/exists.php
import Constants from 'offline/constants'
import User from 'offline/model/user'

export default function(params) {
	var name = String(params.name || '').trim().toLowerCase()
	var key = params.key || false

	if (key) {
		return Promise.reject({
			error: 'This action is not available offline.',
			offline: true
		})
	}

	if (!name) {
		return Promise.reject({
			error: Constants.API_ERROR_USER_INVALID,
			offline: true
		})
	}

	var user = User.with('user_name', name)
	if (!user) {
		return Promise.reject({
			error: Constants.API_ERROR_USER_NOTFOUND,
			offline: true
		})
	}

	return Promise.resolve({
		session: { offline: true },
		data: {
			name: user.get_name()
		}
	})
}
